import { render, staticRenderFns } from "./icon-open.vue?vue&type=template&id=135181a7&"
import script from "./icon-open.vue?vue&type=script&lang=js&"
export * from "./icon-open.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports